jQuery(function ($) {
    var $w = $(window);
    var $header = $('#site-header');
    var $container = $header.find('.header-container');
    var $banners = $header.find('.site-banner, .notification-bar');
    if (!$header.length || !$container.length) return;

    var activationDelta = parseInt($header.data('fixed-activation'), 10) || 100;
    var exitHoldDelta = 100;

    var headerBottom = 0;
    var ticking = false;
    var lastY = window.pageYOffset || 0;
    var prevY = lastY;

    var containerHeight = 0;
    var bannerHeight = 0;
    var totalHeaderHeight = 0;

    // -----------------------------
    // HEADER SPACER (replaces body padding)
    // -----------------------------
    var $headerSpacer = $();

    function overlayActive() {
        return $header.hasClass('header-overlay');
    }

    function elemHeight($el) {
        if (!$el || !$el.length) return 0;
        var r = $el[0].getBoundingClientRect();
        var rectH = Math.round(r.height) || 0;
        var jqH = $el.outerHeight() || 0;
        return Math.max(rectH, jqH, 0);
    }

    function ensureHeaderSpacer() {
        if (overlayActive()) return;
        if (!$headerSpacer.length) {
            $headerSpacer = $('<div class="site-header-spacer" aria-hidden="true"></div>');
            $headerSpacer.insertAfter($header);
        }
    }

    function setHeaderSpacer(on) {
        if (overlayActive()) return;
        ensureHeaderSpacer();
        $headerSpacer.css('height', on ? (totalHeaderHeight + 'px') : '');
    }

    function getFixedHeaderBottomPx() {
        if (!$container.length) return 0;
        if (!$container.hasClass('offscreen')) return 0;
        return Math.max(0, Math.round($container[0].getBoundingClientRect().bottom || 0));
    }

    function readHeights() {
        containerHeight = elemHeight($container);

        var bannersActive = !($header.hasClass('header-offscreen') || $container.hasClass('offscreen'));
        bannerHeight = 0;

        if (bannersActive) {
            $banners.each(function () {
                bannerHeight += elemHeight($(this));
            });
        }

        totalHeaderHeight = containerHeight + bannerHeight;
    }

    // -----------------------------
    // PROJECT MENU (#project-menu)
    // -----------------------------
    var $menu = $('#project-menu');

    var menuHeight = 0;
    var menuFixed = false;
    var menuVisible = false;

    var $menuSpacer = $();
    var topSyncFramesRemaining = 0;

    function ensureMenuSpacer() {
        if (!$menu.length) return;
        if (!$menuSpacer.length) {
            $menuSpacer = $('<div class="project-menu-spacer" aria-hidden="true"></div>');
            $menuSpacer.insertBefore($menu);
        }
    }

    function measureMenu() {
        if (!$menu.length) return;

        // Prefer the first UL if present (common nav markup), otherwise measure the root.
        var $ul = $menu.find('ul').first();
        var h = 0;

        if ($ul.length) h = $ul.outerHeight(true) || 0;
        if (h < 1) h = $menu.outerHeight(true) || 0;

        // Keep your minimum height guard
        menuHeight = Math.max(70, Math.round(h));
    }

    function setMenuSpacer(on) {
        if (!$menu.length) return;
        ensureMenuSpacer();
        $menuSpacer.css('height', on ? (menuHeight + 'px') : '');
    }

    function syncMenuTop() {
        if (!$menu.length || !menuFixed) return;

        var headerBottom = getFixedHeaderBottomPx();
        if (headerBottom > 0) {
            $menu.css('top', headerBottom + 'px');
        }

        if (topSyncFramesRemaining > 0) {
            topSyncFramesRemaining--;
            requestAnimationFrame(syncMenuTop);
        }
    }

    function pinMenu(hidden) {
        if (!$menu.length) return;

        var headerBottom = getFixedHeaderBottomPx();
        if (headerBottom <= 0) return;

        setMenuSpacer(true);

        $menu.addClass('fixed').css('top', headerBottom + 'px');
        $menu.toggleClass('menu-entering', !!hidden);
        $menu.toggleClass('menu-visible', !hidden);

        menuFixed = true;
        menuVisible = !hidden;

        topSyncFramesRemaining = 48;
        requestAnimationFrame(syncMenuTop);
    }

    function unpinMenu() {
        if (!$menu.length) return;

        $menu.removeClass('fixed menu-entering menu-visible').css('top', '');
        menuFixed = false;
        menuVisible = false;

        setMenuSpacer(false);
    }

    function menuFullyOutOfView() {
        if (!$menu.length) return false;
        if (menuFixed) return true;

        var el = $menu.find('ul').first()[0] || $menu[0];
        var rect = el.getBoundingClientRect();

        var BUFFER = 10;
        return (rect.bottom <= (0 - BUFFER));
    }

    function updateMenu() {
        if (!$menu.length) return;

        if (overlayActive()) {
            if (menuFixed) unpinMenu();
            $menu.removeClass('menu-out-of-view');
            return;
        }

        measureMenu();
        ensureMenuSpacer();

        var isOut = menuFullyOutOfView();
        $menu.toggleClass('menu-out-of-view', isOut);

        // Only bring menu back once header is fully visible-fixed
        var headerReady = $container.hasClass('offscreen') && $container.hasClass('fixed') && getFixedHeaderBottomPx() > 0;

        if (!headerReady) {
            if (menuFixed) unpinMenu();
            return;
        }

        if (isOut) {
            if (!menuFixed) {
                // Pin hidden first, then reveal.
                pinMenu(true);

                // Tighten seam: reveal + re-sync top across 2 frames
                requestAnimationFrame(function () {
                    $menu.css('top', getFixedHeaderBottomPx() + 'px');

                    $menu.removeClass('menu-entering').addClass('menu-visible');
                    menuVisible = true;

                    requestAnimationFrame(function () {
                        $menu.css('top', getFixedHeaderBottomPx() + 'px');
                    });
                });
            } else {
                // Already pinned: keep top tight while scrolling
                $menu.css('top', getFixedHeaderBottomPx() + 'px');
            }
        } else {
            if (menuFixed) unpinMenu();
        }
    }

    // -----------------------------
    // Scrollspy
    // -----------------------------
    var $menuLinks = $menu.length ? $menu.find('a[href^="#"]:not([href="#"])') : $();
    var sections = [];
    var activeId = null;

    function mapSections() {
        sections = [];
        if (!$menuLinks.length) return;

        $menuLinks.each(function () {
            var href = this.getAttribute('href');
            if (!href || href.charAt(0) !== '#') return;

            var id = href.slice(1);
            var $t = $('#' + CSS.escape(id));
            if ($t.length) sections.push({ id: id, $el: $t, top: 0 });
        });

        var seen = {};
        sections = sections.filter(function (s) {
            if (seen[s.id]) return false;
            seen[s.id] = true;
            return true;
        });
    }

    function updateSectionTops() {
        sections.forEach(function (s) {
            var off = s.$el.offset();
            s.top = off ? (off.top || 0) : 0;
        });
        sections.sort(function (a, b) { return a.top - b.top; });
    }

    function setCurrent(id) {
        if (id === activeId) return;
        activeId = id;

        $menu.find('.current').removeClass('current');
        if (!id) return;

        $menuLinks.each(function () {
            var href = this.getAttribute('href');
            if (href && href.slice(1) === id) {
                $(this).addClass('current').closest('li').addClass('current');
            }
        });
    }

    function updateCurrentByScroll(y) {
        if (!sections.length || !$menu.length) return;

        var offset = getFixedHeaderBottomPx() + (menuVisible ? menuHeight : 0) + 1;
        var viewY = y + offset;

        var current = null;
        for (var i = 0; i < sections.length; i++) {
            if (sections[i].top <= viewY) current = sections[i];
            else break;
        }

        setCurrent(current ? current.id : null);
    }

    // -----------------------------
    // Measure + update loop
    // -----------------------------
    function measure() {
        readHeights();
        headerBottom = ($header.offset().top || 0) + totalHeaderHeight;

        ensureHeaderSpacer();

        if ($menu.length) {
            measureMenu();
            ensureMenuSpacer();
        }

        mapSections();
        updateSectionTops();
    }

    function teardownAll() {
        $container.removeClass('offscreen fixed exiting');
        $header.removeClass('header-offscreen');
        setHeaderSpacer(false);

        if (menuFixed) unpinMenu();
        if ($menu.length) $menu.removeClass('menu-out-of-view');
    }

    function update() {
        ticking = false;

        var distancePast = (lastY || 0) - headerBottom;
        var fixedRemovalThreshold = Math.max(0, activationDelta - exitHoldDelta);
        var scrollingUp = lastY < prevY;

        if (distancePast >= 0) {
            var wasOffscreen = $container.hasClass('offscreen');

            if (!wasOffscreen) {
                // Measure BEFORE toggling offscreen (banners still present)
                readHeights();

                // Lock layout space BEFORE removing from flow
                setHeaderSpacer(true);

                $container.addClass('offscreen').removeClass('exiting');
                $header.addClass('header-offscreen');
            }

            if (distancePast >= activationDelta) {
                $container.addClass('fixed').removeClass('exiting');
            } else {
                if (scrollingUp) {
                    $container.addClass('exiting');
                    if (distancePast >= fixedRemovalThreshold) $container.addClass('fixed');
                    else $container.removeClass('fixed');
                } else {
                    $container.removeClass('exiting fixed');
                }
            }
        } else {
            teardownAll();
            prevY = lastY;
            return;
        }

        updateMenu();
        updateCurrentByScroll(lastY);
        prevY = lastY;
    }

    function onScroll() {
        lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }

    // init
    measure();
    update();

    window.addEventListener('scroll', onScroll, { passive: true });

    var resizeTimer;
    function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            measure();

            if (menuFixed) {
                setMenuSpacer(true);
                topSyncFramesRemaining = 48;
                requestAnimationFrame(syncMenuTop);
            }

            update();
        }, 100);
    }
    $w.on('resize orientationchange', onResize);

    $w.on('header:remeasure', function () {
        measure();

        if (menuFixed) {
            setMenuSpacer(true);
            topSyncFramesRemaining = 48;
            requestAnimationFrame(syncMenuTop);
        }

        update();
    });

    // keep visible on hover/focus
    $container.on('focusin mouseenter', function () {
        if ($container.hasClass('offscreen') && !$container.hasClass('fixed')) {
            $container.addClass('fixed');
            $header.addClass('header-offscreen');
            updateMenu();
        }
    });
});
